import React from "react";
import classnames from "classnames";

const HeaderValue = ({
  sortBy,
  sortOrder,
  accessor,
  children,
  onSortChange
}) => (
  <span
    className={classnames("table__header-value", {
      sortable: sortBy || sortOrder,
      desc: sortBy == accessor && sortOrder != "asc",
      asc: sortBy == accessor && sortOrder == "asc"
    })}
    onClick={() => {
      if (!accessor) {
        return;
      }
      if (sortBy == accessor) {
        onSortChange({
          sortBy,
          sortOrder: sortOrder == "asc" ? "desc" : "asc"
        });
      } else {
        onSortChange({ sortBy: accessor, sortOrder });
      }
    }}
  >
    {children}
  </span>
);

export default HeaderValue;
